import { Root, LogoContainer, StyledCycleLogo } from './ChangelogBuilderContent.styles';
import { ChangelogBuilderContentSocial } from './ChangelogBuilderContentSocial';
import { ChangelogBuilderContentSubtitle } from './ChangelogBuilderContentSubtitle';
import { ChangelogBuilderContentTitle } from './ChangelogBuilderContentTitle';

export const ChangelogBuilderContent = () => {
  return (
    <Root>
      <LogoContainer>
        <StyledCycleLogo size={30} full color="themed" />
      </LogoContainer>
      <ChangelogBuilderContentTitle />
      <ChangelogBuilderContentSubtitle />
      <ChangelogBuilderContentSocial />
    </Root>
  );
};
